/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { CallProviderVehicleFragmentDoc } from '../../../../ad-operator-call/src/lib/components/CallProvider/CallProvider.hook'
import { AdAlertFeedCardVehicleFragmentDoc } from '../../../../ad-operator-drawer/src/lib/AdAlertFeedCard/AdAlertFeedCard.hook'
import { AdVehicleStreamHubReturnVehicleFragmentDoc } from '../../../../ad-vehicle-stream/src/lib/HubReturn/graphql/HubReturnVehicle.hook'
import { AdVehicleStreamServiceCancellationVehicleFragmentDoc } from '../../../../ad-vehicle-stream/src/lib/ManageService/ManageService.hook'
import { MapAlertDrawerTaskFragmentDoc } from '../../../../alert-drawer/src/lib/MapAlertDrawer.hook'
import { HereMapViewVehicleFragmentDoc } from '../../../../fleet-maps-common/src/lib/components/HereMap/hereMapView.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import {
  HasHubReturnNextFragmentDoc,
  InLocationFragmentDoc,
  IsBookableFragmentDoc,
  IsRebalancingFragmentDoc,
} from '../../../../vehicle-common/src/lib/utils/vehicleValidators.hook'

const defaultOptions = {} as const
export type AdFleetMapVehiclesQueryVariables = Types.Exact<{
  regionId: Types.Scalars['String']['input']
  taskNotificationTypes:
    | Array<Types.TaskNotificationType>
    | Types.TaskNotificationType
  taskNotificationStatus:
    | Array<Types.TaskNotificationStatus>
    | Types.TaskNotificationStatus
  withAdAlerts: Types.Scalars['Boolean']['input']
  withHandlingOperator: Types.Scalars['Boolean']['input']
  role?: Types.InputMaybe<Types.FccOperatorRoleType>
}>

export type AdFleetMapVehiclesQuery = {
  __typename?: 'Query'
  fleetMapVehicles: {
    __typename?: 'FleetMapVehicles'
    vehicles: Array<{
      __typename?: 'Vehicle'
      id: string
      label: number | null
      inService: boolean | null
      openedBy: Types.VehicleInteractionUserType | null
      isResponsive: boolean | null
      isSelfDriving: boolean
      notInServiceReasons: Array<Types.NotInServiceReason> | null
      isWheelchairAccessible: boolean | null
      totalWheelchairUsersInVehicle: number | null
      engineType: Types.VehicleEngineType | null
      highVoltageBatteryLevel: number | null
      interiorTemperature: number | null
      fleet: { __typename?: 'Fleet'; id: string } | null
      currentlyLocatedInServiceBreakLocation: {
        __typename?: 'ServiceBreakLocation'
        id: string
      } | null
      taskNotifications: {
        __typename?: 'TaskNotificationList'
        tasks: Array<
          | {
              __typename?: 'HubServiceNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'IvcTaskNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'PassengerUnbuckled'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'RoadBlockageTaskNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'ShiftDeviationNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopAccessibilityDownvotedByDrivers'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopActivationFailedNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopAreaMissingActiveStopsNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopDownVotedByDrivers'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopPotentiallyUnreachable'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopValidationFailed'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'TimeManagementNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename: 'TripPrebookingNoAssignment'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              rejectionAt: string
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  id: string
                  username: string
                } | null
              } | null
              trip: {
                __typename?: 'Trip'
                id: string
                customer: {
                  __typename?: 'Customer'
                  id: string
                  firstName: string | null
                  lastName: string | null
                  phoneNumber: string | null
                } | null
                pickup: {
                  __typename?: 'TripTransferInformation'
                  promisedTime: {
                    __typename?: 'DateTimeInterval'
                    from: string
                    to: string
                  }
                }
                seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
              } | null
              resolved: {
                __typename?: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
              } | null
              pickupStop: {
                __typename?: 'Stop'
                id: string
                names: Partial<Record<'de' | 'en' | 'no', string>>
                address: {
                  __typename?: 'StopAddress'
                  street: string | null
                  houseNumber: string | null
                  postalCode: string | null
                  city: string | null
                }
                routingLocation: {
                  __typename?: 'Location'
                  latitude: number
                  longitude: number
                }
              } | null
              dropoffStop: {
                __typename?: 'Stop'
                id: string
                names: Partial<Record<'de' | 'en' | 'no', string>>
                address: {
                  __typename?: 'StopAddress'
                  street: string | null
                  houseNumber: string | null
                  postalCode: string | null
                  city: string | null
                }
                routingLocation: {
                  __typename?: 'Location'
                  latitude: number
                  longitude: number
                }
              } | null
              stateChanges: Array<{
                __typename: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
                timestamp: string | null
                to: Types.TaskNotificationStatus
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  username: string
                } | null
              }>
            }
          | {
              __typename?: 'VehicleAvailabilityNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'VehicleIncidentNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename: 'VehicleSurveillanceNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  id: string
                  username: string
                } | null
              } | null
              employee: {
                __typename?: 'Employee'
                id: string
                firstName: string | null
                lastName: string | null
              } | null
              vehicle: {
                __typename?: 'Vehicle'
                id: string
                highVoltageBatteryLevel: number | null
                cruisingRange: number | null
                totalPassengersInVehicle: number | null
                inService: boolean | null
                label: number | null
                licensePlate: string | null
                isSelfDriving: boolean
                hardwareConfiguration: {
                  __typename?: 'HardwareConfiguration'
                  tablet: {
                    __typename?: 'Tablet'
                    phoneNumber: string | null
                  } | null
                } | null
                fleet: { __typename?: 'Fleet'; id: string } | null
                lastVehicleInteraction: {
                  __typename?: 'VehicleInteraction'
                  type: Types.VehicleInteractionType
                } | null
              } | null
              stateChanges: Array<{
                __typename: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
                timestamp: string | null
                to: Types.TaskNotificationStatus
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  username: string
                } | null
              }>
            }
          | {
              __typename?: 'VehicleWaypointAttendance'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
        >
      } | null
      latestADTelemetry: {
        __typename?: 'ADTelemetry'
        centralLockLocked: {
          __typename?: 'ADTelemetryBooleanWithTimestamp'
          value: boolean
        } | null
        sdsMode: {
          __typename?: 'SDSModeWithTimestamp'
          sdsMode: Types.SdsMode
        } | null
      } | null
      nextHubReturn: {
        __typename?: 'HubReturn'
        type: Types.HubReturnType
        scheduledArrival: string
        area: { __typename?: 'Area'; id: string } | null
      } | null
      nextWaypoint: {
        __typename?: 'Waypoint'
        visible: boolean
        waypointActions: Array<{
          __typename?: 'WaypointAction'
          kind: Types.WaypointActionKind
          reallocationRadius: number | null
        }>
        stop: {
          __typename?: 'Stop'
          routingLocation: {
            __typename?: 'Location'
            latitude: number
            longitude: number
          }
        } | null
      } | null
      latestLocation: {
        __typename?: 'VehicleLocation'
        heading: number | null
        timestamp: string | null
        location: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        } | null
      } | null
      fccCurrentAdAlerts: {
        __typename?: 'FccAdAlerts'
        alerts: Array<{
          __typename?: 'FccAdAlert'
          id: string
          type: Types.FccAdAlertType
          status: Types.FccAdAlertStatus
          createdAt: string
          assignee: { __typename?: 'BackofficeUser'; id: string } | null
        }>
      } | null
      fccUpcomingWaypoints: Array<{
        __typename?: 'FccWaypoint'
        adState: Types.FccWaypointState | null
        actions: Array<
          | {
              __typename: 'FccWaypointDeliveryAction'
              id: string
              estimatedAt: string
              pickedUpAt: string | null
              trip: { __typename?: 'Trip'; id: string } | null
              ridePassengerInfo: {
                __typename?: 'FccRidePassengerInfo'
                customerId: string | null
                displayName: string | null
                boardingRequirements: {
                  __typename?: 'FccBoardingRequirements'
                  wheelchair: boolean
                  headCount: number
                  childSeat: boolean
                } | null
                impairments: {
                  __typename?: 'FccImpairments'
                  visual: boolean
                } | null
              } | null
              customer: {
                __typename?: 'Customer'
                firstName: string | null
                lastName: string | null
                extendedWalkingTime: boolean
                visualImpairment: boolean | null
              } | null
            }
          | {
              __typename: 'FccWaypointHubReturnAction'
              id: string
              reason: Types.FccWaypointHubReturnReason
              estimatedAt: string
              isPlannedHubReturn: boolean
            }
          | {
              __typename: 'FccWaypointPickupAction'
              id: string
              estimatedAt: string
              pickedUpAt: string | null
              adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
              notShownUpAt: string | null
              tripIsCancelled: boolean | null
              trip: { __typename?: 'Trip'; id: string } | null
              ridePassengerInfo: {
                __typename?: 'FccRidePassengerInfo'
                customerId: string | null
                displayName: string | null
                boardingRequirements: {
                  __typename?: 'FccBoardingRequirements'
                  wheelchair: boolean
                  headCount: number
                  childSeat: boolean
                } | null
                impairments: {
                  __typename?: 'FccImpairments'
                  visual: boolean
                } | null
              } | null
              customer: {
                __typename?: 'Customer'
                firstName: string | null
                lastName: string | null
                extendedWalkingTime: boolean
                visualImpairment: boolean | null
              } | null
            }
          | { __typename: 'FccWaypointReallocationAction'; estimatedAt: string }
        >
        fccStop: {
          __typename?: 'FccStop'
          id: string | null
          names: Partial<Record<'de' | 'en' | 'no', string>>
        } | null
        stopWithServiceArea: {
          __typename?: 'Stop'
          id: string
          serviceArea: { __typename?: 'ServiceArea'; id: string }
        } | null
      }> | null
      region: { __typename?: 'Region'; id: string } | null
      pooling: {
        __typename?: 'Pooling'
        enabled: boolean
        reason: Types.PoolingReason | null
        connected: boolean | null
      } | null
      fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
      fccHandledByOperatorDetails: {
        __typename?: 'BackofficeUser'
        firstName: string
        lastName: string
      } | null
      fccHandledByRs: {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      } | null
      fccHandledByRao: {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      } | null
      roleScopedAdAlerts: {
        __typename?: 'FccAdAlerts'
        alerts: Array<{
          __typename: 'FccAdAlert'
          id: string
          type: Types.FccAdAlertType
          createdAt: string
          status: Types.FccAdAlertStatus
        }>
      } | null
      ignition: {
        __typename?: 'Ignition'
        ignitionState: Types.IgnitionState | null
        updatedAt: string | null
      } | null
    }>
  }
}

export type AdFleetMapVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  label: number | null
  inService: boolean | null
  openedBy: Types.VehicleInteractionUserType | null
  isResponsive: boolean | null
  isSelfDriving: boolean
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  isWheelchairAccessible: boolean | null
  totalWheelchairUsersInVehicle: number | null
  engineType: Types.VehicleEngineType | null
  highVoltageBatteryLevel: number | null
  interiorTemperature: number | null
  fleet: { __typename?: 'Fleet'; id: string } | null
  currentlyLocatedInServiceBreakLocation: {
    __typename?: 'ServiceBreakLocation'
    id: string
  } | null
  taskNotifications: {
    __typename?: 'TaskNotificationList'
    tasks: Array<
      | {
          __typename?: 'HubServiceNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'IvcTaskNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerUnbuckled'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'RoadBlockageTaskNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'ShiftDeviationNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAccessibilityDownvotedByDrivers'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopActivationFailedNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAreaMissingActiveStopsNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopDownVotedByDrivers'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopPotentiallyUnreachable'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopValidationFailed'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'TimeManagementNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename: 'TripPrebookingNoAssignment'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          rejectionAt: string
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
            backofficeUser: {
              __typename?: 'BackofficeUser'
              id: string
              username: string
            } | null
          } | null
          trip: {
            __typename?: 'Trip'
            id: string
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              phoneNumber: string | null
            } | null
            pickup: {
              __typename?: 'TripTransferInformation'
              promisedTime: {
                __typename?: 'DateTimeInterval'
                from: string
                to: string
              }
            }
            seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
          } | null
          resolved: {
            __typename?: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
          } | null
          pickupStop: {
            __typename?: 'Stop'
            id: string
            names: Partial<Record<'de' | 'en' | 'no', string>>
            address: {
              __typename?: 'StopAddress'
              street: string | null
              houseNumber: string | null
              postalCode: string | null
              city: string | null
            }
            routingLocation: {
              __typename?: 'Location'
              latitude: number
              longitude: number
            }
          } | null
          dropoffStop: {
            __typename?: 'Stop'
            id: string
            names: Partial<Record<'de' | 'en' | 'no', string>>
            address: {
              __typename?: 'StopAddress'
              street: string | null
              houseNumber: string | null
              postalCode: string | null
              city: string | null
            }
            routingLocation: {
              __typename?: 'Location'
              latitude: number
              longitude: number
            }
          } | null
          stateChanges: Array<{
            __typename: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
            timestamp: string | null
            to: Types.TaskNotificationStatus
            backofficeUser: {
              __typename?: 'BackofficeUser'
              username: string
            } | null
          }>
        }
      | {
          __typename?: 'VehicleAvailabilityNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleIncidentNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename: 'VehicleSurveillanceNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
            backofficeUser: {
              __typename?: 'BackofficeUser'
              id: string
              username: string
            } | null
          } | null
          employee: {
            __typename?: 'Employee'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          vehicle: {
            __typename?: 'Vehicle'
            id: string
            highVoltageBatteryLevel: number | null
            cruisingRange: number | null
            totalPassengersInVehicle: number | null
            inService: boolean | null
            label: number | null
            licensePlate: string | null
            isSelfDriving: boolean
            hardwareConfiguration: {
              __typename?: 'HardwareConfiguration'
              tablet: {
                __typename?: 'Tablet'
                phoneNumber: string | null
              } | null
            } | null
            fleet: { __typename?: 'Fleet'; id: string } | null
            lastVehicleInteraction: {
              __typename?: 'VehicleInteraction'
              type: Types.VehicleInteractionType
            } | null
          } | null
          stateChanges: Array<{
            __typename: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
            timestamp: string | null
            to: Types.TaskNotificationStatus
            backofficeUser: {
              __typename?: 'BackofficeUser'
              username: string
            } | null
          }>
        }
      | {
          __typename?: 'VehicleWaypointAttendance'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
    >
  } | null
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    centralLockLocked: {
      __typename?: 'ADTelemetryBooleanWithTimestamp'
      value: boolean
    } | null
    sdsMode: {
      __typename?: 'SDSModeWithTimestamp'
      sdsMode: Types.SdsMode
    } | null
  } | null
  nextHubReturn: {
    __typename?: 'HubReturn'
    type: Types.HubReturnType
    scheduledArrival: string
    area: { __typename?: 'Area'; id: string } | null
  } | null
  nextWaypoint: {
    __typename?: 'Waypoint'
    visible: boolean
    waypointActions: Array<{
      __typename?: 'WaypointAction'
      kind: Types.WaypointActionKind
      reallocationRadius: number | null
    }>
    stop: {
      __typename?: 'Stop'
      routingLocation: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      }
    } | null
  } | null
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    timestamp: string | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      createdAt: string
      assignee: { __typename?: 'BackofficeUser'; id: string } | null
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              wheelchair: boolean
              headCount: number
              childSeat: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          id: string
          reason: Types.FccWaypointHubReturnReason
          estimatedAt: string
          isPlannedHubReturn: boolean
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              wheelchair: boolean
              headCount: number
              childSeat: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
        }
      | { __typename: 'FccWaypointReallocationAction'; estimatedAt: string }
    >
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
  }> | null
  region: { __typename?: 'Region'; id: string } | null
  pooling: {
    __typename?: 'Pooling'
    enabled: boolean
    reason: Types.PoolingReason | null
    connected: boolean | null
  } | null
  fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
  fccHandledByOperatorDetails: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  fccHandledByRs: {
    __typename?: 'BackofficeUser'
    id: string
    firstName: string
    lastName: string
  } | null
  fccHandledByRao: {
    __typename?: 'BackofficeUser'
    id: string
    firstName: string
    lastName: string
  } | null
  roleScopedAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      createdAt: string
      status: Types.FccAdAlertStatus
    }>
  } | null
  ignition: {
    __typename?: 'Ignition'
    ignitionState: Types.IgnitionState | null
    updatedAt: string | null
  } | null
}

export const AdFleetMapVehicleFragmentDoc = gql`
    fragment AdFleetMapVehicle on Vehicle {
  id
  label
  fleet {
    id
  }
  currentlyLocatedInServiceBreakLocation {
    id
  }
  ...IsBookable
  ...InLocation
  ...HasHubReturnNext
  ...IsRebalancing
  ...HereMapViewVehicle
  ...CallProviderVehicle
  ...AdVehicleStreamServiceCancellationVehicle
  ...AdVehicleStreamHubReturnVehicle
  ...AdAlertFeedCardVehicle
  taskNotifications(
    types: $taskNotificationTypes
    status: $taskNotificationStatus
  ) {
    tasks {
      id
      status
      severity
      ...MapAlertDrawerTask
    }
  }
  latestADTelemetry {
    centralLockLocked {
      value
    }
  }
}
    ${IsBookableFragmentDoc}
${InLocationFragmentDoc}
${HasHubReturnNextFragmentDoc}
${IsRebalancingFragmentDoc}
${HereMapViewVehicleFragmentDoc}
${CallProviderVehicleFragmentDoc}
${AdVehicleStreamServiceCancellationVehicleFragmentDoc}
${AdVehicleStreamHubReturnVehicleFragmentDoc}
${AdAlertFeedCardVehicleFragmentDoc}
${MapAlertDrawerTaskFragmentDoc}`
export const AdFleetMapVehiclesDocument = gql`
    query AdFleetMapVehicles($regionId: String!, $taskNotificationTypes: [TaskNotificationType!]!, $taskNotificationStatus: [TaskNotificationStatus!]!, $withAdAlerts: Boolean!, $withHandlingOperator: Boolean!, $role: FccOperatorRoleType) {
  fleetMapVehicles(input: {regionId: $regionId, isSelfDriving: true}) {
    vehicles {
      ...AdFleetMapVehicle
    }
  }
}
    ${AdFleetMapVehicleFragmentDoc}`

/**
 * __useAdFleetMapVehiclesQuery__
 *
 * To run a query within a React component, call `useAdFleetMapVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdFleetMapVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdFleetMapVehiclesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      taskNotificationTypes: // value for 'taskNotificationTypes'
 *      taskNotificationStatus: // value for 'taskNotificationStatus'
 *      withAdAlerts: // value for 'withAdAlerts'
 *      withHandlingOperator: // value for 'withHandlingOperator'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAdFleetMapVehiclesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  > &
    (
      | { variables: AdFleetMapVehiclesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
export function useAdFleetMapVehiclesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
// @ts-ignore
export function useAdFleetMapVehiclesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdFleetMapVehiclesQuery,
  AdFleetMapVehiclesQueryVariables
>
export function useAdFleetMapVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdFleetMapVehiclesQuery,
        AdFleetMapVehiclesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdFleetMapVehiclesQuery | undefined,
  AdFleetMapVehiclesQueryVariables
>
export function useAdFleetMapVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdFleetMapVehiclesQuery,
        AdFleetMapVehiclesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
export type AdFleetMapVehiclesQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesQuery
>
export type AdFleetMapVehiclesLazyQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesLazyQuery
>
export type AdFleetMapVehiclesSuspenseQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesSuspenseQuery
>
export type AdFleetMapVehiclesQueryResult = Apollo.QueryResult<
  AdFleetMapVehiclesQuery,
  AdFleetMapVehiclesQueryVariables
>
